export default __webpack_public_path__ + "static/media/Group911110.921590a9.svg";